import {persistedStore} from '../Mobx'
import {dashboardStore} from '../Screens/Dashboard/Dashboard/Store'

export const IsChildUserActive = () => {
  const {User} = dashboardStore
  const {MainUser} = persistedStore
  const isChildUserSelected = MainUser?.MainUserGuid !== User?.MainUserGuid
  return isChildUserSelected
}
